import React, { useState, useEffect } from 'react';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Modal from 'react-bootstrap/Modal';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import ClientCrudService from '../../services/ClientCrudService';
import dateFormat from 'dateformat';
import Accordion from 'react-bootstrap/Accordion';

export default function ModalMultiRoles({ show, handleClose, dataItem, setRenderRows }) {

  const [validated, setValidated] = useState(false);
  const conditionView = (dataItem.typeView === 'View' || dataItem.typeView === 'Delete') ? true : false;
  const [getAllPlans, setGetAllPlans] = useState([]);
  const [suscriptionsPlans, setSuscriptionsPlans] = useState([]);
  const [periodPrice, setPeriodPrice] = useState('');

  const [userName, setUserName] = useState(null);
  const [userUserName, setUserUserName] = useState(null);
  const [userPath, setUserPath] = useState(null);
  const [providerType, setProviderType] = useState('');
  const [suscriptionCode, setSuscriptionCode] = useState('');
  const [suscriptionPeriod, setSuscriptionPeriod] = useState('');
  const [suscriptionExpires, setSuscriptionExpires] = useState(null);
  const [t1dataShopId, setT1dataShopId] = useState(null);
  const [sellerId, setSellerId] = useState();
  const [progressConfig, setProgressConfig] = useState({});
  const [dataInfoPlan, setDataInfoPlan] = useState([]);
  const [t1SuscriptionId, sett1SuscriptionId] = useState(null);
  const [enableChangePlan, setEnableChangePlan] = useState(true);

  useEffect(() => {
    if (show && dataItem.codeItem > 0) {

      ClientCrudService.getAllPlans().then(async res => {
        setGetAllPlans(res.data.data);
      });

      ClientCrudService.getClientById(730).then(async res => {

        let currentClient = res.data.data[0];

        setUserName(currentClient.name);
        setUserUserName(currentClient.username);
        setUserPath(currentClient.path);
        setProviderType(currentClient.providerType);
        setSuscriptionCode(currentClient.suscription_id.planCode);
        setSuscriptionExpires(currentClient.suscription_id.expiresOn);
        setT1dataShopId(currentClient.t1data.shopId);
        setProgressConfig(currentClient.progressConfig);
        setPeriodPrice("By " + currentClient.suscription_id.periodType + " $ " + currentClient.suscription_id.price);
        sett1SuscriptionId(currentClient.suscription_id.t1SuscriptionId);
        setSellerId(currentClient.salesChannel.seller_id);

      });
    } else {

      setUserName(null);
      setUserUserName(null);
      setUserPath(null);
      setProviderType('');
      setSuscriptionCode('');
      setSuscriptionExpires(null);
      setT1dataShopId(null);
      setSellerId(null);
      setProgressConfig({});
      setGetAllPlans([]);
      setPeriodPrice('');
      setSuscriptionsPlans([]);
      sett1SuscriptionId(null);
      setDataInfoPlan([]);
      setSuscriptionPeriod('');
      setEnableChangePlan(true);

    }
  }, [dataItem, show]);

  useEffect(() => {
    if (userName && dataInfoPlan === null) {

      ClientCrudService.getSuscripcionPlan(t1SuscriptionId).then(async res => {

        let currentDataInfoPlan = res.data.data;
        setDataInfoPlan(dataInfoPlan => [...dataInfoPlan, currentDataInfoPlan.suscripcion]);

      });
    }
  }, [userName, dataInfoPlan, t1SuscriptionId]);

  const handleSubmit = async (event) => {
    const form = event.currentTarget;

    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();

    } else {

      let updatePlanClient = { planCode: suscriptionCode, suscription: suscriptionPeriod, expiresOn: suscriptionExpires };

      //console.log('idClient => ' + JSON.stringify(dataItem.codeItem));
      //console.log(updatePlanClient);

      ClientCrudService.updatePlanClient(updatePlanClient, dataItem.codeItem).then(res => {
        handleClose();
        ClientCrudService.getAllClients().then(async res => {
          setRenderRows(res.data.data);
        });
      });

    }

    setValidated(true);
  };

  const changeSuscriptionCodeHandler = (event) => {
    setSuscriptionCode(event.target.value);
    let plan = getAllPlans.find((obj) => obj['code'] == event.target.value);
    setSuscriptionsPlans(plan.suscriptions);
    setEnableChangePlan(false);
  }

  const changePlanPeriodHandler = (event) => {

    const current = new Date();
    let indexPeriod = event.target.value;

    if (indexPeriod == 2)
      current.setMonth(current.getMonth() + 24);

    if (indexPeriod == 1)
      current.setMonth(current.getMonth() + 12);

    if (indexPeriod == 0)
      current.setMonth(current.getMonth() + 1);

    setSuscriptionPeriod(indexPeriod);
    setSuscriptionExpires(current);
  }

  const changeSuscriptionExpiresHandler = (event) => {
    //console.log("***********event.target.value********************");
    //console.log(event.target.value);
    setSuscriptionExpires(event.target.value);
  }

  let addSubmitButton = "";
  if (!conditionView) {
    addSubmitButton = (<><Button type="submit" disabled={enableChangePlan}>Change Plan</Button></>);
  }

  const setCloseButton = <><Button variant="secondary" onClick={handleClose}> Close </Button> {'  '}  {'  '} </>;

  return (
    <>
      <Modal size="lg" show={show} onHide={handleClose} backdrop="static">
        <Modal.Header>
          <Modal.Title> {dataItem.typeView} {dataItem.nameView} </Modal.Title>
        </Modal.Header>
        <Modal.Body>

          <Tabs
            defaultActiveKey="main"
            id="justify-tab-example"
            className="mb-3"
            justify
          >
            <Tab eventKey="main" title={"Data " + dataItem.nameView}>

            Codes <pre>
          {JSON.stringify(dataItem.codeItem, null, 2)}
        </pre>

              <hr></hr>
              {setCloseButton}
            </Tab>

            <Tab eventKey="tabAction" title="Action">
              <Form noValidate validated={validated} onSubmit={handleSubmit}>
                <Row className="mb-3">
                  <Accordion>

                  {dataInfoPlan.map((itemPlan, index) => {
                    return (<Accordion.Item eventKey={index}>
                      <Accordion.Header>Suscripcion Plan</Accordion.Header>
                      <Accordion.Body>
                        <pre>
                          {JSON.stringify(itemPlan, null, 2)}
                        </pre>
                      </Accordion.Body>
                    </Accordion.Item>
                  )
                  })}

                  </Accordion>
                </Row>
                <hr></hr>
                {setCloseButton}

              </Form>
            </Tab>

          </Tabs>

        </Modal.Body>
      </Modal>
    </>
  );
}